export default __webpack_public_path__ + "media/images/shadow-237ee117ef2fb0d74b8c8125c1627988.png";